import i18n from '../i18n/i18n';

function translateSuspiciousReason(reason: string) {
  const key = `entity.vehicle.labels.${reason}`;
  const translated = i18n.t(key);

  return translated === key ? reason : translated;
}

export function formatSuspiciousReasons(reasons: string[] | null | undefined) {
  if (!reasons?.length) {
    return null;
  }

  return reasons.map(translateSuspiciousReason).join(', ');
}
